import { groupBy } from 'lodash'

import { JobCatalogPerson } from 'modules/job_catalog/pages/NodePage/PeoplePage/useJobCatalogPeople'

import { JobCatalogGenderData } from './models'

const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
} as const

export const useJobCatalogGenderData = (people: JobCatalogPerson[], isLevel: boolean) => {
  let data: JobCatalogGenderData[]
  let keys: string[]
  if (!isLevel) {
    data = calculateNodeDistribution(people)
    keys = ['Men', 'Women', 'Not declared']
  } else {
    data = calculateLevelDistribution(people)
    keys = ['Total']
  }

  const percentageOfPeople = (condition: (person: JobCatalogPerson) => boolean) => {
    return roundToTwoDecimals((people.filter(condition).length / people.length) * 100)
  }

  const roundToTwoDecimals = (num: number): number => Math.round((num + Number.EPSILON) * 100) / 100

  return {
    data,
    keys,
    count: people.length,
    malePercentage: percentageOfPeople(isMale),
    femalePercentage: percentageOfPeople(isFemale),
    notDeclaredPercentage: percentageOfPeople(isNotDeclaredGender),
  }
}

function calculateNodeDistribution(people: JobCatalogPerson[]) {
  const peopleGroupedByChildrenNodes = groupBy(people, 'nodeGroupName')
  return Object.keys(peopleGroupedByChildrenNodes).map((childKey) => ({
    id: childKey,
    Men: peopleGroupedByChildrenNodes[childKey]?.filter(isMale).length ?? 0,
    Women: peopleGroupedByChildrenNodes[childKey]?.filter(isFemale).length ?? 0,
    'Not declared': peopleGroupedByChildrenNodes[childKey]?.filter(isNotDeclaredGender).length ?? 0,
  }))
}

function calculateLevelDistribution(people: JobCatalogPerson[]) {
  return [
    {
      id: 'Men',
      Total: people.filter(isMale).length,
    },
    {
      id: 'Women',
      Total: people.filter(isFemale).length,
    },
    {
      id: 'Not declared',
      Total: people.filter(isNotDeclaredGender).length,
    },
  ]
}

function isMale(person: JobCatalogPerson): boolean {
  return person.employeeGender === GENDERS.MALE
}

function isFemale(person: JobCatalogPerson): boolean {
  return person.employeeGender === GENDERS.FEMALE
}

function isNotDeclaredGender(person: JobCatalogPerson): boolean {
  return !person.employeeGender
}
